<script setup lang="ts">
  defineProps<{
    title: string;
  }>();
</script>

<template>
  <section>
    <h3 class="heading-section mb-3">{{ title }}</h3>
    <ul class="space-y-2 text-sm">
      <slot />
    </ul>
  </section>
</template>
